export default __webpack_public_path__ + "static/media/Goat-Portal-logo.cc8aa370.svg";